<template>
  <div class="depth">
    <!-- 标题 -->
    <div
      style="
        margin: 30px auto;
        text-align: center;
        font-family: 'cooper-black', sans-serif;
        font-size: 36px;
        color: black;
      "
    >
      Core Depth to Core Composite Depth and Splice
    </div>
    <!-- 副标题 -->
    <div class="dec">
      Convert the depth of individual cores (mbsf or CSF-A) so that the features
      are aligned on a common depth scale (mcd or CCSF) by identifying offsets.
      Then, combine selected intervals between cores at a site based on the tie
      points established in the shipboard analysis to construct a better record.
    </div>
    <!-- 主体 -->
    <div class="main">
      <!-- 左侧 -->
      <div class="left">
        <!-- 左侧标题 -->
        <div class="title">
          <div class="top">
            <h2 style="font-weight: bold">Affine</h2>
            <div class="notice" @click="downloadExcelLeft">
              Template and Guidelines
            </div>
          </div>
          <div class="bottom">
            Convert the depth of individual cores to common depth scale
          </div>
        </div>
        <!-- 图片 -->
        <div class="img">
          <img :src="leftImg" alt="图" />
        </div>
        <!-- 下拉框 -->
        <div class="ipt">
          <div>
            Site：<el-select v-model="siteLeft" placeholder="请选择">
              <el-option
                v-for="item in optionsLeft"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div style="font-size: 18px; line-height: 40px" v-show="showTipLeft">
            {{ tipLeft }}
          </div>
        </div>
        <!-- <div style="margin: 10px 0;">请按此模板上传：<el-button type="warning" @click="downloadExcelLeft">Template</el-button> -->
        <!-- </div> -->
        <!-- 按钮区域 -->
        <a-alert
          type="error"
          message="Error text"
          banner
          v-show="showxianshi"
        />
        <div class="btn">
          <el-upload
            class="upload-demo"
            action="http://106.55.9.16:8386/AffineUpload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileListLeft"
            :on-success="handleSuccessLeft"
            :on-error="handleError"
            :style="upLightLeft ? 'background:red;' : ''"
            :disabled="!upLightLeft"
          >
            <div :style="upLightLeft ? 'background:red;' : ''">Upload</div>
          </el-upload>
          <div @click="start(0)" :style="statrLeft ? 'background:red' : ''">
            Start
          </div>
          <div @click="affineDown" :style="downLeft ? 'background:red' : ''">
            Download
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="right">
        <!-- 右侧标题 -->
        <div class="title">
          <div class="top">
            <h2 style="font-weight: bold">Splice</h2>
            <div class="notice" @click="downloadExcelRight">
              Template and Guidelines
            </div>
          </div>
          <div class="bottom">Combine selected intervals between cores</div>
        </div>
        <!-- 图片 -->
        <div class="img">
          <img :src="rightImg" alt="图" />
        </div>
        <!-- 下拉区域 -->
        <div class="ipt">
          <div>
            Site：
            <el-select v-model="siteRight" placeholder="请选择">
              <el-option
                v-for="item in optionsRight"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div style="font-size: 18px; line-height: 40px" v-show="showTipRight">
            {{ tipRight }}
          </div>
        </div>
        <!-- <div style="margin: 10px 0;">请按此模板上传：<el-button type="warning" @click="downloadExcelRight">Template</el-button> -->
        <!-- </div> -->
        <!-- 按钮区域 -->
        <div class="btn">
          <el-upload
            class="upload-demo"
            action="http://106.55.9.16:8386/SpliceUpload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileListRight"
            :on-success="handleSuccessRight"
            :on-error="handleError"
            :style="upLightRight ? 'background:red;' : ''"
            :disabled="!upLightRight"
          >
            <div :style="upLightRight ? 'background:red' : ''">Upload</div>
          </el-upload>
          <div @click="start(1)" :style="statrRight ? 'background:red' : ''">
            Start
          </div>
          <div @click="spliceDown" :style="downRight ? 'background:red' : ''">
            Download
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; margin-top: 150px; margin-bottom: 0px">
      <div style="width: 50%; text-align: center">
        <div
          style="
            margin: 0 auto;
            font-family: 'Microsoft YaHei', sans-serif;
            font-size: 22px;
            color: red;
          "
        >
          Affine Table Example
        </div>
        <el-table
          :data="tableDataLeft"
          stripe
          style="width: 95%; margin-top: 20px"
        >
          <el-table-column prop="exp" label="Expedition" />
          <el-table-column prop="site" label="Site" />
          <el-table-column prop="hole" label="Hole" />
          <el-table-column prop="Index_Value" label="Index Value" width="180" />
          <el-table-column
            prop="Depth_CSF_A_m"
            label="Depth CSF-A (m)"
            width="180"
          />
        </el-table>
      </div>
      <div
        style="
          width: 2px;
          border: 2px dashed black;
          height: 230px;
          margin-right: 28px;
        "
      ></div>
      <div style="width: 50%; text-align: center">
        <div
          style="
            margin: 0 auto;
            font-family: 'Microsoft YaHei', sans-serif;
            font-size: 22px;
            color: red;
          "
        >
          Splice Table Example
        </div>
        <el-table
          :data="tableDataRight"
          stripe
          style="width: 95%; margin-top: 20px"
        >
          <el-table-column prop="exp" label="Expedition" />
          <el-table-column prop="site" label="Site" />
          <el-table-column prop="hole" label="Hole" />
          <el-table-column prop="Index_Value" label="Index_Value" width="120" />
          <el-table-column
            prop="Depth_CSF_A_m"
            label="Depth CSF-A (m)"
            width="140"
          />
          <el-table-column
            prop="Depth_CCSF_m"
            label="Depth_CCSF_m"
            width="140"
          />
        </el-table>
      </div>
    </div>
    <div
      id="main"
      style="width: 80vw; height: 600px; margin: 0 auto"
      v-show="showEcharts"
    ></div>
    <div
      style="width: 90vw; height: 600px; margin: 0 auto; text-align: center"
      v-show="!showEcharts"
    >
      <img :src="img" alt="" style="" />
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import d1 from '../assets/d1.jpg';
import d2 from '../assets/d2.jpg';
import {
  AffineStart,
  AffineDownload,
  SpliceStart,
  SpliceDownload,
} from '@/api/request';
import img from '../assets/test.png';
export default {
  name: 'depthName',
  data() {
    return {
      img: img,
      tipLeft: '',
      tipRight: '',
      showTipRight: false,
      showTipLeft: false,
      thatIs: '',
      // 左侧下拉框值
      siteLeft: '',
      // 右侧下拉框值
      siteRight: '',
      upLightLeft: false,
      upLightRight: false,
      fileListLeft: [],
      fileListRight: [],
      leftImg: d1,
      rightImg: d2,
      showImgLeft: false,
      showImgRight: false,
      showxianshi: false,
      showEcharts: false,
      optionsLeft: [
        { value: '1483' },
        { value: '1485' },
        { value: '1486' },
        { value: '1488' },
        { value: '1489' },
        { value: '1490' },
        { value: '1510' },
        { value: 'U1443' },
        { value: 'U1445' },
        { value: 'U1446' },
        { value: 'U1447' },
        { value: 'U1448' },
        { value: 'U1456' },
        { value: 'U1457' },
        { value: 'U1459' },
        { value: 'U1461' },
        { value: 'U1463' },
        { value: 'U1464' },
        { value: 'U1467' },
        { value: 'U1473' },
        { value: 'U1474' },
        { value: 'U1475' },
        { value: 'U1476' },
        { value: 'U1478' },
        { value: 'U1479' },
        { value: 'U1482' },
        { value: 'U1487' },
      ],
      optionsRight: [
        { value: '1482' },
        { value: '1483' },
        { value: '1484' },
        { value: '1485' },
        { value: '1486' },
        { value: '1487' },
        { value: '1488' },
        { value: '1489' },
        { value: '1490' },
        { value: '1510' },
        { value: 'U1443' },
        { value: 'U1445' },
        { value: 'U1446' },
        { value: 'U1447' },
        { value: 'U1448' },
        { value: 'U1456' },
        { value: 'U1457' },
        { value: 'U1461' },
        { value: 'U1463' },
        { value: 'U1464' },
        { value: 'U1467' },
        { value: 'U1474' },
        { value: 'U1475' },
        { value: 'U1476' },
        { value: 'U1478' },
        { value: 'U1479' },
      ],
      statrLeft: false,
      statrRight: false,
      leftFile: '',
      rightFile: '',
      mockData: [],
      downLeft: false,
      downRight: false,
      tableDataLeft: [
        {
          exp: 361,
          site: 'U1474',
          hole: 'A',
          Index_Value: 20.49,
          Depth_CSF_A_m: 0,
        },
        {
          exp: 361,
          site: 'U1474',
          hole: 'A',
          Index_Value: 37.17,
          Depth_CSF_A_m: 0.025,
        },
      ],
      tableDataRight: [
        {
          exp: 361,
          site: 'U1474',
          hole: 'A',
          Index_Value: 20.49,
          Depth_CSF_A_m: 0,
          Depth_CCSF_m: 0,
        },
        {
          exp: 361,
          site: 'U1474',
          hole: 'A',
          Index_Value: 37.17,
          Depth_CSF_A_m: 0.025,
          Depth_CCSF_m: 0.025,
        },
      ],
    };
  },
  watch: {
    siteLeft: function (value) {
      console.log(value);
      this.upLightLeft = true;
    },
    siteRight: function (value) {
      console.log(value);
      this.upLightRight = true;
    },
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    spliceDown() {
      let that = this;

      try {
        SpliceDownload()
          .then((response) => {
            console.log(response);
            const url = window.URL.createObjectURL(
              new Blob([response], { type: 'application/vnd.ms-excel' })
            );
            const link = document.createElement('a');
            console.log(url);
            link.href = url;
            link.setAttribute('download', 'SpliceOut.xlsx'); // 指定下载的文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // 清理创建的 URL
            that.upLightRight = false;
            that.statrRight = false;
            that.downRight = false;
            that.fileListRight = [];
          })
          .catch((error) => {
            console.error('下载文件时出错:', error);
            this.$message.error('文件下载失败'); // 使用Element UI或其他UI框架的消息提示组件
          });
      } catch (error) {
        console.log(error);
      }
    },
    affineDown() {
      let that = this;
      try {
        AffineDownload()
          .then((response) => {
            console.log('repsponse', response.data);
            // const fileReader = new FileReader()
            // fileReader.readAsDataURL(response)
            // fileReader.onload = (res) => {
            //   console.log("reader Res", res)
            // }
            console.log('响应类型111111：', response); // 检查响应类型
            console.log('响应大小：', response.size); // 检查响应内容大小
            const url = window.URL.createObjectURL(
              new Blob([response], { type: 'application/vnd.ms-excel' })
            );
            // const url = response.url || response;
            const link = document.createElement('a');
            console.log(url);
            link.href = url;
            link.setAttribute('download', 'AffineConvert.xlsx'); // 指定下载的文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url); // 清理创建的 URL
            that.upLightLeft = false;
            that.statrLeft = false;
            that.downLeft = false;
            that.fileListLeft = [];
          })
          .catch((error) => {
            console.error('下载文件时出错:', error);
            this.$message.error('文件下载失败'); // 使用Element UI或其他UI框架的消息提示组件
          });
      } catch (error) {
        console.log(error);
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file, 'file');
    },
    handleExceed(files, fileList) {
      this.thatIs = this;
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    // beforeRemove(file, fileList) {
    //   // return this.$confirm(`确定移除 ？`);
    // },
    handleSuccessLeft(response, file, fileList) {
      console.log(response, file, fileList);
      this.leftFile = fileList[0].raw;
      // this.statrLeft = true
      this.showTipLeft = response.code ? true : false;
      switch (response.code) {
        case '0':
          this.tipLeft = '✅ Site Ready！';
          this.statrLeft = true;
          break;
        case '1':
          this.tipLeft = '⚠ Sorry, please upload. xlsx .xls file！';
          this.statrLeft = false;
          break;
        default:
          this.tipLeft = '⚠ Sorry, please upload the correct column name！';
          this.statrLeft = false;

          break;
      }
      // this.$message({
      //   showClose: true,
      //   message: response.msg,
      //   type: response.code == '0' ?'success': 'error' });
    },
    handleSuccessRight(response, file, fileList) {
      console.log(response, file, fileList);

      this.rightFile = fileList[0].raw;
      //  this.$message({
      //     showClose: true,
      //     message: response.msg,
      //     type: response.code == '0' ?'success': 'error' });
      this.showTipRight = response.code ? true : false;
      switch (response.code) {
        case '0':
          this.tipRight = '✅ Site Ready！';
          this.statrRight = true;
          break;
        case '1':
          this.tipRight = '⚠ Sorry, please upload. xlsx .xls file！';
          this.statrRight = false;
          break;
        default:
          this.tipRight = '⚠ Sorry, please upload the correct column name！';
          this.statrRight = false;

          break;
      }
    },
    handleError() {},
    async start(v) {
      const formData = new FormData();
      let that = this;
      // const thatIs = this.thatIs;
      if (!v) {
        // 左

        await formData.set('file', this.leftFile);
        await formData.set('requestSite', this.siteLeft);
        console.log('this.siteLeft', this.siteLeft);
        console.log('formData', formData);
        try {
          AffineStart(formData).then((res) => {
            console.log(res);
            if (res.state == 500) {
              console.log(res.res);
              //console.log(Message)
              //that.showxianshi = true
              that.$message.error(res.res);
              return;
            }
            // that.showEcharts = true
            that.downLeft = true;
            // 将返回结果保存到 localStorage
            localStorage.setItem('affineStartResult', JSON.stringify(res));
          });
        } catch (error) {
          console.log(error);
        }
        console.log('左');
      } else {
        // 右
        await formData.set('file', this.rightFile);
        await formData.set('requestSite', this.siteRight);
        try {
          SpliceStart(formData).then((res) => {
            // 读取响应头信息

            console.log(res, 'res');
            if (res.status == 500) {
              this.$message.error('文件与site不对应');
              return;
            }
            localStorage.setItem('SpliceStart', res.tableName);
            that.mockData = res.groupedData;

            // console.log(mockData);
            that.showEcharts = true;
            console.log(this.showEcharts);
            if (that.showEcharts) that.init(console.log(this.showEcharts));
            that.downRight = true;
          });
        } catch (error) {
          console.log(error);
        }
        console.log('右');
      }
    },
    init() {
      let mockData = this.mockData;

      console.log(mockData, 'mockdata');
      var colors = [
        '#F266AB',
        '#1CD6CE',
        '#6C4AB6',
        '#687EFF',
        '#A55233',
        '#053742',
        '#FFB84C',
        '#FF0060',
        '#C86B85',
        '#247881',
        '#F2FF9B',
      ];
      var option = {
        // title: {
        //   text: 'Distribution of Index Value by Depth for Various Holes'
        // },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c}',
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20,
        },
        xAxis: {
          type: 'value',
          name: 'Depth CCSF (m)',
          splitLine: { show: false },
        },
        yAxis: {
          type: 'value',
          name: 'Index Value',
        },
        series: [],
      };
      console.log(option.legend); // 查看当前状态

      // 添加系列到图表配置
      Object.keys(mockData).forEach((hole, index) => {
        // var sortedData = mockData[hole].sort(
        //   (a, b) => a.depth_CCSF_m - b.depth_CCSF_m
        // );
        option.series.push({
          name: 'Hole ' + hole,
          type: 'scatter',
          smooth: true,
          data: mockData[hole].map((item) => [
            item.depth_CCSF_m,
            item.index_Value,
          ]),
          itemStyle: {
            color: colors[index % colors.length],
          },
          symbolSize: 3,
          lineStyle: {
            color: colors[index % colors.length],
            width: 2,
          },
        });
      });

      var chart = echarts.init(document.getElementById('main'));
      chart.setOption(option);
    },
    downloadExcelLeft() {
      var a = document.createElement('a'); //创建一个<a></a>标签
      a.href = '/static//Affine_Input.xlsx';
      console.log(a.href);
      //给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.download = 'Affine_Input.xlsx';
      //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      a.style.display = 'none'; // 障眼法藏起来a标签
      document.body.appendChild(a);
      // 将a标签追加到文档对象中
      a.click(); //模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove();
      // 一次性的，用完就删除a标签
    },
    downloadExcelRight() {
      var a = document.createElement('a'); //创建一个<a></a>标签
      a.href = '/static/Splice_Input.xlsx';
      //给a标签的href属性值加上地址，注意，这里是绝对路径，不用加 点.
      a.download = 'Splice_Input.xlsx';
      //设置下载文件文件名，这里加上.xlsx指定文件类型，pdf文件就指定.fpd即可
      a.style.display = 'none'; // 障眼法藏起来a标签
      document.body.appendChild(a);
      // 将a标签追加到文档对象中
      a.click(); //模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove();
      // 一次性的，用完就删除a标签
    },
  },
};
</script>

<style scoped>
.depth {
  height: 100%;
  background-color: #fff;
  padding: 20px;
}
h1 {
  text-align: center;
}
.dec {
  text-align: center;
  padding: 0 150px;
  font-size: 18px;
  color: black;
}
.main {
  width: 100%;
  display: flex;
  justify-content: space-around;
  height: 400px;
  margin-top: 30px;
  margin-bottom: 50px;
}
.left {
  width: 35%;
  padding: 20px;
}
.right {
  width: 35%;
  padding: 20px;
  /* background-color: blue; */
}
.top {
  display: flex;
  justify-content: space-between;
  color: black;
  font-size: 16px;
}
.bottom {
  color: black;
  font-size: 16px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.img {
  width: 80%;
  height: 300px;
  /* background-color: red; */
}
img {
  /* width: 100%; */
  height: 100%;
}
.ipt {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
}
.btn {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.btn div {
  width: 30%;
  background-color: #d9d9d9;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: white;
  border-radius: 10px;
  cursor: pointer;
}
.notice {
  background: #dca550;
  padding: 10px;
  border-radius: 10px;
  color: white;
  cursor: pointer;
}
</style>
